export default "__VITE_ASSET__CJUf8fSb__"